module.exports = __webpack_public_path__ + "img/eye_icon_patient_list.4ff7bd17.svg";